import Vue from 'vue'
import CONFIG from './../../config.js'
let actions = {
  activeTransaction (context, txn) {
    localStorage.setItem("activeTxn", JSON.stringify(txn))
    context.commit('activeTransaction', txn)
  },
  settledTransactions (context, query) {
    context.commit('addLog', { request:'settledTxn' })
    return new Promise((resolve, reject) => {
      if(query.append){
        query = query.params
      }
      Vue.axios.get(CONFIG.getEndpoint('settledTransactions'), {
        params: query,
        withCredentials: true
      }).then((response) => {
        context.commit('settledTransactions', {
          response:response.data.settledTransactionList,
          append:query.append
        })
        context.commit('removeLog', { request:'settledTxn' })
        resolve()
      }).catch((err)=>{
        context.commit('settledTxnError', { status:true })
        context.commit('removeLog', { request:'settledTxn' })
        reject()
      })
   })
  }
}
export default actions



// WEBPACK FOOTER //
// ./src/store/transaction/actions.js